<template>
  <div class="workflow-form">
    <div class="review-action-button" v-if="!showSubmitBtn">
      <div class="btn-more" ref="reviewMore" @click="more" v-if="permission.length > 2"><i class="iconfont icon-more-ui"/></div>
      <div class="btn-r">
        <div :class=[per] v-for="(per, index) in permission" v-if="permission.length >= 2 && index < 2" :key="per" @click="handleAction(per)">{{statusText[per]}}</div>
      </div>
      <div class="popover" v-if="showMore">
        <ul>
          <li v-for="(per, index) in permission" :key="index" v-if="index > 1" @click="handleAction(per)">{{statusText[per]}}</li>
        </ul>
      </div>
    </div>
    <div  v-else :class="['submit-btn', ((this.$props.spStatus === 1 && !this.$props.opinionMessage) || ((!this.$props.nodeId || !this.$props.backMessage) && this.$route.query.showBack)) && 'disabled']" @click="handleSubmit">
      确认
    </div>
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'
import config from '@/config'
import { find } from 'lodash'
import ajax from '@/utils/ajax'
import {WORKFLOW_APPROVAL} from '@/config/api'
import { Toast } from 'vant'

const statusText = {
  'agree': '同意',
  'disagree': '不同意',
  'back': '退回'
}

export default {
  name: 'WorkflowForm',
  i18n,
  components: {
  },
  props: {
    currentNodeIndex: Number,
    opinionMessage: String,
    backMessage: String,
    nodeId: [Object, Number],
    spStatus: Number,
    workflowInfo: Object,
    fileList: Array
  },
  data () {
    return {
      showMore: false,
      showSubmitBtn: JSON.stringify(this.$route.query) !== '{}',
      statusText: statusText
    }
  },
  watch: {
    $route (to, from) {
      this.showMore = !!to.query.showMore
      this.showSubmitBtn = JSON.stringify(to.query) !== '{}' && !this.showMore
    }
  },
  computed: {
    permission () {
      const { currentUserRole, nodes, workflowStatus } = this.$props.workflowInfo
      let arr = []
      let currentNodeIndex = this.$props.currentNodeIndex
      let loginApprover
      for (let i = 0; i < nodes.length; i++) {
        loginApprover = find(nodes[i].approveUsers, (item) => {
          return item.approveUser && item.approveUser.id === config.user_info.id
        })
        if (loginApprover) break
      }

      const isCurrentApprover = currentUserRole === 3 && loginApprover && loginApprover.taskStatus === 1
      const roleInfo = this.getUserRoleJudge(currentUserRole)

      if (isCurrentApprover) {
        arr = ['disagree', 'agree']
      }
      if (isCurrentApprover && nodes[currentNodeIndex].sendBack) {
        arr.push('back')
      }
      if (roleInfo.isInitiator && [2, 3, 5, 6].includes(workflowStatus)) {
        // 再次发起
        arr.push('submitAgain')
      }
      if (roleInfo.isInitiator && (workflowStatus === 3 || (workflowStatus === 7 && currentNodeIndex === 0))) {
        // 重新发起
        arr.push('reSubmit')
      }
      console.log('permissions...', arr)
      return arr
    }
  },
  created () {
    this.workflowInfo = this.$props.workflowInfo
  },
  methods: {
    more () {
      this.toggleQuery('showMore')
    },
    getUserRoleJudge (id) {
      const USER_ROLE = {
        initiator: 1,
        CcUser: 2,
        approver: 3
      }
      return {
        isInitiator: id === USER_ROLE.initiator,
        isApprover: id === USER_ROLE.approver,
        isCcUser: id === USER_ROLE.CcUser
      }
    },
    handleAction (action) {
      if (action === 'back') {
        this.showMore = false
        this.$router.push({ query: {showBack: action} })
      } else {
        this.$router.push({ query: {showActions: action} })
      }
    },
    handleSubmit () {
      if ((this.$props.spStatus === 1 && !this.$props.opinionMessage) || ((!this.$props.nodeId || !this.$props.backMessage) && this.$route.query.showBack)) {
        return false
      }
      // 同意 or 不同意
      let data = {
        attachments: [], // 附件 [{fileId: 203000000, name: 'cccc.docx', size: 33333, type: 'docx'}]
        comment: this.opinionMessage || '',
        pass: this.$route.query.showActions === 'agree', // 同意true, 不同意及退回 false
        taskId: Number(this.$route.params.id)

      }
      if (this.$route.query.showBack) {
        data.targetTempNodeId = this.$props.nodeId
        data.comment = this.$props.backMessage
      }
      if (this.$props.fileList && this.$props.fileList.length) {
        data.attachments = this.$props.fileList.map(item => {
          const { id, name, size, type } = item
          return {
            fileId: id,
            name,
            size,
            type
          }
        })
      }
      ajax({
        url: WORKFLOW_APPROVAL,
        data
      }).then(res => {
        if (res && res.success) {
          Toast('操作成功')
          this.$router.push({ query: {} })
        } else {
          Toast('操作失败')
        }
      })
    }
  }
}
</script>
<style lang="postcss">
@import 'variables';

.message-card {
  & .van-cell {
    padding-left: 0;
    padding-bottom: 16px;
    padding-top: 0;
    & .van-field__body {
      & .van-field__control {
        line-height: 22px;
        color: #626F84;
        min-height: 70px;
      }
    }
  }
}

</style>
